import React from 'react';
import "swiper/css";
import { Button } from '../../ui'
import { formatMemory } from '../../libs';
import { HorizontalRuleOutlined, StarBorderPurple500Outlined, DeleteOutlineOutlined } from '@mui/icons-material';


export function MediaSettings({ visible, handleClose, handleDelete, handleSetCover, handleToggleFavorite, media, isOwner }) {

    const height = isOwner ? 'h-40' : 'h-20';

    return (
        <div className={`position-fixed bottom-0 start-0 w-100 h-100 bg-dark d-flex align-items-end z-1000 bg-opacity-50 ${visible ? 'visibility-visible' : 'visibility-invisible pe-none'}`}
            onClick={handleClose}>
            <div className={`bg-secondary bg-opacity-50 w-100 p-2 transition-base gap-1 rounded-top d-flex justify-content-start align-items-center flex-column pb-5 ${visible ? height : ' h-0'}`} onClick={(e) => e.stopPropagation()}>
                <HorizontalRuleOutlined className="text-white" fontSize="large" />
                <h5 className="text-white mb-0">
                    Dimensione: {formatMemory(media?.size)}
                </h5>
                <h5 className="text-white mb-0">
                    Tipo file: {media?.type}
                </h5>
                <h5 className="text-white">
                    Caricata da: {media?.owner}
                </h5>
                <div className="d-flex gap-2 flex-column w-100 h-100 justify-content-space-around">
                    {media?.favorite
                        ? <Button onClick={handleToggleFavorite}>
                            Rimuovi dai preferiti
                        </Button>
                        : <Button onClick={handleToggleFavorite}>
                            <StarBorderPurple500Outlined className={'me-2'} fontSize="small" />
                            Inserisci tra i preferiti
                            <StarBorderPurple500Outlined className={'ms-2'} fontSize="small" />
                        </Button>
                    }
                    {isOwner && <Button onClick={handleSetCover} otherClass={"btn-secondary"}>
                        Imposta come foto copertina
                    </Button>}
                    {/* 
                <Button otherClass={"btn-secondary text-white"} onClick={handleButton}>
                    Scarica originale
                </Button> */}
                    {isOwner && <Button otherClass={"btn-danger text-white"} onClick={handleDelete}>
                        <DeleteOutlineOutlined className=" me-2 fs-3" />
                        Elimina
                    </Button>}
                </div>
            </div>
        </div>
    );
}